!function() {
    "use strict";
    var t = function() {
        return (t = Object.assign || function(t) {
            for (var e, i = 1, n = arguments.length; i < n; i++)
                for (var o in e = arguments[i])
                    Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
            return t
        }
        ).apply(this, arguments)
    };
    function e(t, e, i) {
        if (i || 2 == arguments.length)
            for (var n, o = 0, r = e.length; o < r; o++)
                !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)),
                n[o] = e[o]);
        return t.concat(n || Array.prototype.slice.call(e))
    }
    function i(t) {
        return Array.prototype.slice.call(t)
    }
    function n(t, e) {
        var i = Math.floor(t);
        return i === e || i + 1 === e ? t : e
    }
    function o() {
        return Date.now()
    }
    function r(t, e, i) {
        if (e = "data-keen-slider-" + e,
        null === i)
            return t.removeAttribute(e);
        t.setAttribute(e, i || "")
    }
    function l(t, e) {
        return e = e || document,
        "function" == typeof t && (t = t(e)),
        Array.isArray(t) ? t : "string" == typeof t ? i(e.querySelectorAll(t)) : t instanceof HTMLElement ? [t] : t instanceof NodeList ? i(t) : []
    }
    function s(t) {
        t.raw && (t = t.raw),
        t.cancelable && !t.defaultPrevented && t.preventDefault()
    }
    function a(t) {
        t.raw && (t = t.raw),
        t.stopPropagation && t.stopPropagation()
    }
    function d() {
        var t = [];
        return {
            add: function(e, i, n, o) {
                e.addListener ? e.addListener(n) : e.addEventListener(i, n, o),
                t.push([e, i, n, o])
            },
            input: function(t, e, i, n) {
                this.add(t, e, function(t) {
                    t.nativeEvent && (t = t.nativeEvent);
                    var e = t.changedTouches || []
                      , n = t.targetTouches || []
                      , o = t.detail && t.detail.x ? t.detail : null;
                    return i({
                        id: o ? o.identifier ? o.identifier : "i" : n[0] ? n[0] ? n[0].identifier : "e" : "d",
                        idChanged: o ? o.identifier ? o.identifier : "i" : e[0] ? e[0] ? e[0].identifier : "e" : "d",
                        raw: t,
                        x: o && o.x ? o.x : n[0] ? n[0].screenX : o ? o.x : t.pageX,
                        y: o && o.y ? o.y : n[0] ? n[0].screenY : o ? o.y : t.pageY
                    })
                }, n)
            },
            purge: function() {
                t.forEach(function(t) {
                    t[0].removeListener ? t[0].removeListener(t[2]) : t[0].removeEventListener(t[1], t[2], t[3])
                }),
                t = []
            }
        }
    }
    function u(t, e, i) {
        return Math.min(Math.max(t, e), i)
    }
    function v(t) {
        return (t > 0 ? 1 : 0) - (t < 0 ? 1 : 0) || +t
    }
    function c(t) {
        var e = t.getBoundingClientRect();
        return {
            height: n(e.height, t.offsetHeight),
            width: n(e.width, t.offsetWidth)
        }
    }
    function h(t, e, i, n) {
        var o = t && t[e];
        return null == o ? i : n && "function" == typeof o ? o() : o
    }
    function g(t) {
        return Math.round(1e6 * t) / 1e6
    }
    function p(t) {
        var e, i, n, o, r, l, s, a;
        function d(t) {
            return 1 - Math.pow(1 - t, 3)
        }
        function c() {
            return n ? t.track.velocity() : 0
        }
        function h(t, e) {
            void 0 === e && (e = 1e3);
            var i = 147e-9 + (t = Math.abs(t)) / e;
            return {
                dist: Math.pow(t, 2) / i,
                dur: t / i
            }
        }
        function g() {
            var e = t.track.details;
            e && (r = e.min,
            l = e.max,
            s = e.minIdx,
            a = e.maxIdx)
        }
        function p() {
            t.animator.stop()
        }
        t.on("updated", g),
        t.on("optionsChanged", g),
        t.on("created", g),
        t.on("dragStarted", function() {
            n = !1,
            p(),
            e = i = t.track.details.abs
        }),
        t.on("dragChecked", function() {
            n = !0
        }),
        t.on("dragEnded", function() {
            var n, g, m, f, b, y, S = t.options.mode;
            "snap" === S && (n = t.track,
            m = (g = t.track.details).position,
            f = v(c()),
            (m > l || m < r) && (f = 0),
            b = e + f,
            0 === g.slides[n.absToRel(b)].portion && (b -= f),
            e !== i && (b = i),
            v(n.idxToDist(b, !0)) !== f && (b += f),
            b = u(b, s, a),
            y = n.idxToDist(b, !0),
            t.animator.start([{
                distance: y,
                duration: 500,
                easing: function(t) {
                    return 1 + --t * t * t * t * t
                }
            }])),
            "free" !== S && "free-snap" !== S || function() {
                p();
                var e = "free-snap" === t.options.mode
                  , i = t.track
                  , n = c();
                o = v(n);
                var g = t.track.details
                  , m = [];
                if (n || !e) {
                    var f = h(n)
                      , b = f.dist
                      , y = f.dur;
                    if (y *= 2,
                    b *= o,
                    e) {
                        var S = i.idxToDist(i.distToIdx(b), !0);
                        S && (b = S)
                    }
                    m.push({
                        distance: b,
                        duration: y,
                        easing: d
                    });
                    var k = g.position
                      , x = k + b;
                    if (x < r || x > l) {
                        var E = x < r ? r - k : l - k
                          , w = 0
                          , D = n;
                        if (v(E) === o) {
                            var I = Math.min(Math.abs(E) / Math.abs(b), 1)
                              , T = (1 - Math.pow(1 - I, 1 / 3)) * y;
                            m[0].earlyExit = T,
                            D = n * (1 - I)
                        } else
                            m[0].earlyExit = 0,
                            w += E;
                        var C = h(D, 100)
                          , A = C.dist * o;
                        t.options.rubberband && (m.push({
                            distance: A,
                            duration: 2 * C.dur,
                            easing: d
                        }),
                        m.push({
                            distance: -A + w,
                            duration: 500,
                            easing: d
                        }))
                    }
                    t.animator.start(m)
                } else
                    t.moveToIdx(u(g.abs, s, a), !0, {
                        duration: 500,
                        easing: function(t) {
                            return 1 + --t * t * t * t * t
                        }
                    })
            }()
        }),
        t.on("dragged", function() {
            i = t.track.details.abs
        })
    }
    function m(t) {
        var e, i, n, o, r, c, h, g, p, m, f, b, y, S, k, x, E, w, D = d();
        function I(e) {
            if (c && g === e.id) {
                var l = B(e);
                if (p) {
                    if (!A(e))
                        return C(e);
                    m = l,
                    p = !1,
                    t.emit("dragChecked")
                }
                if (x)
                    return m = l;
                s(e);
                var d = function(e) {
                    if (E === -1 / 0 && w === 1 / 0)
                        return e;
                    var n = t.track.details
                      , l = n.length
                      , s = n.position
                      , a = u(e, E - s, w - s);
                    if (0 === l)
                        return 0;
                    if (!t.options.rubberband)
                        return a;
                    if (s <= w && s >= E || s < E && i > 0 || s > w && i < 0)
                        return e;
                    var d = Math.max(0, 1 - Math.abs((s < E ? s - E : s - w) / l * (o * l)) / r * 2);
                    return d * d * e
                }(h(m - l) / o * n);
                i = v(d);
                var y = t.track.details.position;
                (y > E && y < w || y === E && i > 0 || y === w && i < 0) && a(e),
                f += d,
                !b && Math.abs(f * o) > 5 && (b = !0),
                t.track.add(d),
                m = l,
                t.emit("dragged")
            }
        }
        function T(e) {
            !c && t.track.details && t.track.details.length && (f = 0,
            c = !0,
            b = !1,
            p = !0,
            g = e.id,
            A(e),
            m = B(e),
            t.emit("dragStarted"))
        }
        function C(e) {
            c && g === e.idChanged && (c = !1,
            t.emit("dragEnded"))
        }
        function A(t) {
            var e = L()
              , i = e ? t.y : t.x
              , n = e ? t.x : t.y
              , o = void 0 !== y && void 0 !== S && Math.abs(S - n) <= Math.abs(y - i);
            return y = i,
            S = n,
            o
        }
        function B(t) {
            return L() ? t.y : t.x
        }
        function L() {
            return t.options.vertical
        }
        function O() {
            o = t.size,
            r = L() ? window.innerHeight : window.innerWidth;
            var e = t.track.details;
            e && (E = e.min,
            w = e.max)
        }
        function N(t) {
            b && (a(t),
            s(t))
        }
        function M() {
            if (D.purge(),
            t.options.drag && !t.options.disabled) {
                h = "function" == typeof (o = t.options.dragSpeed || 1) ? o : function(t) {
                    return t * o
                }
                ,
                n = t.options.rtl ? -1 : 1,
                O(),
                e = t.container,
                i = "data-keen-slider-clickable",
                l("[".concat(i, "]:not([").concat(i, "=false])"), e).map(function(t) {
                    D.add(t, "dragstart", a),
                    D.add(t, "mousedown", a),
                    D.add(t, "touchstart", a)
                }),
                D.add(e, "dragstart", function(t) {
                    s(t)
                }),
                D.add(e, "click", N, {
                    capture: !0
                }),
                D.input(e, "ksDragStart", T),
                D.input(e, "ksDrag", I),
                D.input(e, "ksDragEnd", C),
                D.input(e, "mousedown", T),
                D.input(e, "mousemove", I),
                D.input(e, "mouseleave", C),
                D.input(e, "mouseup", C),
                D.input(e, "touchstart", T, {
                    passive: !0
                }),
                D.input(e, "touchmove", I, {
                    passive: !1
                }),
                D.input(e, "touchend", C),
                D.input(e, "touchcancel", C),
                D.add(window, "wheel", function(t) {
                    c && s(t)
                });
                var i, o, r = "data-keen-slider-scrollable";
                l("[".concat(r, "]:not([").concat(r, "=false])"), t.container).map(function(t) {
                    var e;
                    D.input(t, "touchstart", function(t) {
                        e = B(t),
                        x = !0,
                        k = !0
                    }, {
                        passive: !0
                    }),
                    D.input(t, "touchmove", function(i) {
                        var n = L()
                          , o = n ? t.scrollHeight - t.clientHeight : t.scrollWidth - t.clientWidth
                          , r = e - B(i)
                          , l = n ? t.scrollTop : t.scrollLeft
                          , a = n && "scroll" === t.style.overflowY || !n && "scroll" === t.style.overflowX;
                        if (e = B(i),
                        (r < 0 && l > 0 || r > 0 && l < o) && k && a)
                            return x = !0;
                        k = !1,
                        s(i),
                        x = !1
                    }),
                    D.input(t, "touchend", function() {
                        x = !1
                    })
                })
            }
        }
        t.on("updated", O),
        t.on("optionsChanged", M),
        t.on("created", M),
        t.on("destroyed", D.purge)
    }
    function f(t) {
        var e, i, n = null;
        function o(e, i, n) {
            t.animator.active ? l(e, i, n) : requestAnimationFrame(function() {
                return l(e, i, n)
            })
        }
        function r() {
            o(!1, !1, i)
        }
        function l(i, o, r) {
            var l = 0
              , s = t.size
              , u = t.track.details;
            if (u && e) {
                var v = u.slides;
                e.forEach(function(t, e) {
                    if (i)
                        !n && o && a(t, null, r),
                        d(t, null, r);
                    else {
                        if (!v[e])
                            return;
                        var u = v[e].size * s;
                        !n && o && a(t, u, r),
                        d(t, v[e].distance * s - l, r),
                        l += u
                    }
                })
            }
        }
        function s(e) {
            return "performance" === t.options.renderMode ? Math.round(e) : e
        }
        function a(t, e, i) {
            var n = i ? "height" : "width";
            null !== e && (e = s(e) + "px"),
            t.style["min-" + n] = e,
            t.style["max-" + n] = e
        }
        function d(t, e, i) {
            if (null !== e) {
                e = s(e);
                var n = i ? e : 0;
                e = "translate3d(".concat(i ? 0 : e, "px, ").concat(n, "px, 0)")
            }
            t.style.transform = e,
            t.style["-webkit-transform"] = e
        }
        function u() {
            e && (l(!0, !0, i),
            e = null),
            t.on("detailsChanged", r, !0)
        }
        function v() {
            o(!1, !0, i)
        }
        function c() {
            u(),
            i = t.options.vertical,
            t.options.disabled || "custom" === t.options.renderMode || (n = "auto" === h(t.options.slides, "perView", null),
            t.on("detailsChanged", r),
            (e = t.slides).length && v())
        }
        t.on("created", c),
        t.on("optionsChanged", c),
        t.on("beforeOptionsChanged", function() {
            u()
        }),
        t.on("updated", v),
        t.on("destroyed", u)
    }
    "function" == typeof SuppressedError && SuppressedError;
    var b = function(i, n, s) {
        try {
            var a, b, y, S;
            return b = e([(a = {
                drag: !0,
                mode: "snap",
                renderMode: "precision",
                rubberband: !0,
                selector: ".keen-slider__slide"
            },
            function(e) {
                var n, o, s, u, v, g = d();
                function p(t) {
                    var i;
                    r(e.container, "reverse", "rtl" !== (i = e.container,
                    window.getComputedStyle(i, null).getPropertyValue("direction")) || t ? null : ""),
                    r(e.container, "v", e.options.vertical && !t ? "" : null),
                    r(e.container, "disabled", e.options.disabled && !t ? "" : null)
                }
                function m() {
                    f() && k()
                }
                function f() {
                    var i = null;
                    if (u.forEach(function(t) {
                        t.matches && (i = t.__media)
                    }),
                    i === n)
                        return !1;
                    n || e.emit("beforeOptionsChanged"),
                    n = i;
                    var o = i ? s.breakpoints[i] : s;
                    return e.options = t(t({}, s), o),
                    p(),
                    I(),
                    T(),
                    E(),
                    !0
                }
                function b() {
                    return e.options.trackConfig.length
                }
                function y(i) {
                    for (var r in n = !1,
                    s = t(t({}, a), i),
                    g.purge(),
                    o = e.size,
                    u = [],
                    s.breakpoints || []) {
                        var l = window.matchMedia(r);
                        l.__media = r,
                        u.push(l),
                        g.add(l, "change", m)
                    }
                    g.add(window, "orientationchange", D),
                    g.add(window, "resize", w),
                    f()
                }
                function S(t) {
                    e.animator.stop();
                    var i = e.track.details;
                    e.track.init(null != t ? t : i ? i.abs : 0)
                }
                function k(t) {
                    S(t),
                    e.emit("optionsChanged")
                }
                function x(t, i) {
                    if (t)
                        return y(t),
                        void k(i);
                    I(),
                    T();
                    var n = b();
                    E(),
                    b() !== n ? k(i) : S(i),
                    e.emit("updated")
                }
                function E() {
                    var t = e.options.slides;
                    if ("function" == typeof t)
                        return e.options.trackConfig = t(e.size, e.slides);
                    var i = e.slides
                      , n = i.length
                      , o = "number" == typeof t ? t : h(t, "number", n, !0)
                      , r = []
                      , l = h(t, "perView", 1, !0)
                      , s = "number" == typeof l ? h(t, "numberOfFullWidthShow", void 0, !0) : l
                      , a = h(t, "spacing", 0, !0) / e.size || 0
                      , d = "auto" === l ? a : a / l
                      , u = 0;
                    "number" == typeof s && (u = a * (Math.floor(s) - 1));
                    for (var v = h(t, "origin", "auto"), g = 0, p = 0; p < o; p++) {
                        var m = "auto" === l ? function(t) {
                            var i = c(t);
                            return (e.options.vertical ? i.height : i.width) / e.size || 1
                        }(i[p]) - a + d : 1 / l - a + d
                          , f = "center" === v ? "number" == typeof s ? .5 - u / 2 - Math.floor(s) * m / 2 : .5 - m / 2 : "auto" === v ? 0 : v;
                        r.push({
                            origin: f,
                            size: m,
                            spacing: a
                        }),
                        g += m
                    }
                    if (g += a * (o - 1),
                    "auto" === v && !e.options.loop && 1 !== l) {
                        var b = 0;
                        r.map(function(t) {
                            var e = g - b;
                            return b += t.size + a,
                            e >= 1 || (t.origin = 1 - e - (g > 1 ? 0 : 1 - g)),
                            t
                        })
                    }
                    e.options.trackConfig = r
                }
                function w() {
                    I();
                    var t = e.size;
                    e.options.disabled || t === o || (o = t,
                    x())
                }
                function D() {
                    w(),
                    setTimeout(w, 500),
                    setTimeout(w, 2e3)
                }
                function I() {
                    var t = c(e.container);
                    e.size = (e.options.vertical ? t.height : t.width) || 1
                }
                function T() {
                    e.slides = l(e.options.selector, e.container)
                }
                e.container = (v = l(i, document)).length ? v[0] : null,
                e.destroy = function() {
                    g.purge(),
                    e.emit("destroyed"),
                    p(!0)
                }
                ,
                e.prev = function() {
                    e.moveToIdx(e.track.details.abs - 1, !0)
                }
                ,
                e.next = function() {
                    e.moveToIdx(e.track.details.abs + 1, !0)
                }
                ,
                e.update = x,
                y(e.options)
            }
            ), f, m, p], s || [], !0),
            S = {},
            y = {
                emit: function(t) {
                    S[t] && S[t].forEach(function(t) {
                        t(y)
                    });
                    var e = y.options && y.options[t];
                    e && e(y)
                },
                moveToIdx: function(t, e, i) {
                    var n = y.track.idxToDist(t, e);
                    if (n) {
                        var o = y.options.defaultAnimation;
                        y.animator.start([{
                            distance: n,
                            duration: h(i || o, "duration", 500),
                            easing: h(i || o, "easing", function(t) {
                                return 1 + --t * t * t * t * t
                            })
                        }])
                    }
                },
                on: function(t, e, i) {
                    void 0 === i && (i = !1),
                    S[t] || (S[t] = []);
                    var n = S[t].indexOf(e);
                    n > -1 ? i && delete S[t][n] : i || S[t].push(e)
                },
                options: n
            },
            function() {
                if (y.track = function(t) {
                    var i, n, r, l, s, a, d, c, p, m, f, b, y, S, k = 1 / 0, x = [], E = null, w = 0;
                    function D(t) {
                        O(w + t)
                    }
                    function I(t) {
                        var e = T(w + t).abs;
                        return B(e) === e ? e : null
                    }
                    function T(t) {
                        var i = Math.floor(Math.abs(g(t / n)))
                          , o = g((t % n + n) % n);
                        o === n && (o = 0);
                        var r = v(t)
                          , l = d.indexOf(e([], d, !0).reduce(function(t, e) {
                            return Math.abs(e - o) < Math.abs(t - o) ? e : t
                        }))
                          , s = l;
                        return r < 0 && i++,
                        l === a && (s = 0,
                        i += r > 0 ? 1 : -1),
                        {
                            abs: s + i * a * r,
                            origin: l,
                            rel: s
                        }
                    }
                    function C(t, e, i) {
                        if (e || !l.loop)
                            return A(t, i);
                        if (B(t) !== t)
                            return null;
                        var n, o = T(null != i ? i : w), r = o.abs, s = t - o.rel, d = r + s;
                        n = A(d);
                        var u = A(d - a * v(s));
                        return (null !== u && Math.abs(u) < Math.abs(n) || null === n) && (n = u),
                        g(n)
                    }
                    function A(t, e) {
                        if (null == e && (e = g(w)),
                        i = t,
                        B(i) !== i || null === t)
                            return null;
                        t = Math.round(t);
                        var i, o = T(e), r = o.abs, l = o.rel, s = o.origin, u = L(t), v = (e % n + n) % n, c = d[s], h = Math.floor((t - (r - l)) / a) * n;
                        return g(c - v - c + d[u] + h + (s === a ? n : 0))
                    }
                    function B(t) {
                        return u(t, p, m)
                    }
                    function L(t) {
                        return (t % a + a) % a
                    }
                    function O(e) {
                        i = e - w,
                        x.push({
                            distance: i,
                            timestamp: o()
                        }),
                        x.length > 6 && (x = x.slice(-6)),
                        w = g(e);
                        var i, n = N().abs;
                        if (n !== E) {
                            var r = null !== E;
                            E = n,
                            r && t.emit("slideChanged")
                        }
                    }
                    function N(e) {
                        var o = e ? null : function() {
                            if (a) {
                                var t = l.loop
                                  , e = t ? (w % n + n) % n : w
                                  , i = (t ? w % n : w) - s[0][2]
                                  , o = 0 - (i < 0 && t ? n - Math.abs(i) : i)
                                  , d = 0
                                  , u = T(w)
                                  , c = u.abs
                                  , h = u.rel
                                  , g = s[h][2]
                                  , k = s.map(function(e, i) {
                                    var r = o + d;
                                    (r < 0 - e[0] || r > 1) && (r += (Math.abs(r) > n - 1 && t ? n : 0) * v(-r));
                                    var s = i - h
                                      , u = v(s)
                                      , p = s + c;
                                    t && (-1 === u && r > g && (p += a),
                                    1 === u && r < g && (p -= a),
                                    null !== f && p < f && (r += n),
                                    null !== b && p > b && (r -= n));
                                    var m = r + e[0] + e[1]
                                      , y = Math.max(r >= 0 && m <= 1 ? 1 : m < 0 || r > 1 ? 0 : r < 0 ? Math.min(1, (e[0] + r) / e[0]) : (1 - r) / e[0], 0);
                                    return d += e[0] + e[1],
                                    {
                                        abs: p,
                                        distance: l.rtl ? -1 * r + 1 - e[0] : r,
                                        portion: y,
                                        size: e[0]
                                    }
                                });
                                return h = L(c = B(c)),
                                {
                                    abs: B(c),
                                    length: r,
                                    max: S,
                                    maxIdx: m,
                                    min: y,
                                    minIdx: p,
                                    position: w,
                                    progress: t ? e / n : w / r,
                                    rel: h,
                                    slides: k,
                                    slidesLength: n
                                }
                            }
                        }();
                        return i.details = o,
                        t.emit("detailsChanged"),
                        o
                    }
                    return i = {
                        absToRel: L,
                        add: D,
                        details: null,
                        distToIdx: I,
                        idxToDist: C,
                        init: function(e) {
                            var i, o, u, v;
                            if (function() {
                                if (a = (s = ((l = t.options).trackConfig || []).map(function(t) {
                                    return [h(t, "size", 1), h(t, "spacing", 0), h(t, "origin", 0)]
                                })).length) {
                                    n = g(s.reduce(function(t, e) {
                                        return t + e[0] + e[1]
                                    }, 0));
                                    var e, i = a - 1;
                                    r = g(n + s[0][2] - s[i][0] - s[i][2] - s[i][1]),
                                    d = s.reduce(function(t, i) {
                                        if (!t)
                                            return [0];
                                        var n = s[t.length - 1]
                                          , o = t[t.length - 1] + (n[0] + n[2]) + n[1];
                                        return o -= i[2],
                                        t[t.length - 1] > o && (o = t[t.length - 1]),
                                        o = g(o),
                                        t.push(o),
                                        (!e || e < o) && (c = t.length - 1),
                                        e = o,
                                        t
                                    }, null),
                                    0 === r && (c = 0),
                                    d.push(g(n))
                                }
                            }(),
                            !a)
                                return N(!0);
                            i = t.options.range,
                            f = p = (o = t.options.loop) ? h(o, "min", -k) : 0,
                            b = m = o ? h(o, "max", k) : c,
                            u = h(i, "min", null),
                            v = h(i, "max", null),
                            null !== u && (p = u),
                            null !== v && (m = v),
                            y = p === -k ? p : t.track.idxToDist(p || 0, !0, 0),
                            S = m === k ? m : C(m, !0, 0),
                            null === v && (b = m),
                            h(i, "align", !1) && m !== k && 0 === s[L(m)][2] && (S -= 1 - s[L(m)][0],
                            m = I(S - w)),
                            y = g(y),
                            S = g(S),
                            Number(e) === e ? D(A(B(e))) : N()
                        },
                        to: O,
                        velocity: function() {
                            var t = o()
                              , e = x.reduce(function(e, i) {
                                var n = i.distance
                                  , o = i.timestamp;
                                return t - o > 200 || (v(n) !== v(e.distance) && e.distance && (e = {
                                    distance: 0,
                                    lastTimestamp: 0,
                                    time: 0
                                }),
                                e.time && (e.distance += n),
                                e.lastTimestamp && (e.time += o - e.lastTimestamp),
                                e.lastTimestamp = o),
                                e
                            }, {
                                distance: 0,
                                lastTimestamp: 0,
                                time: 0
                            });
                            return e.distance / e.time || 0
                        }
                    }
                }(y),
                y.animator = function(t) {
                    var e, i, n, o, r, l;
                    function s(t) {
                        e.active = t
                    }
                    function a(t) {
                        e.targetIdx = t
                    }
                    function d() {
                        var e;
                        e = r,
                        window.cancelAnimationFrame(e),
                        s(!1),
                        a(null),
                        l && t.emit("animationStopped"),
                        l = null
                    }
                    return e = {
                        active: !1,
                        start: function(e) {
                            if (d(),
                            t.track.details) {
                                var u = 0
                                  , v = t.track.details.position;
                                i = 0,
                                n = 0,
                                o = e.map(function(t) {
                                    var e, i = Number(v), o = null !== (e = t.earlyExit) && void 0 !== e ? e : t.duration, r = t.easing, l = t.distance * r(o / t.duration) || 0;
                                    v += l;
                                    var s = n;
                                    return n += o,
                                    u += l,
                                    [i, t.distance, s, n, t.duration, r]
                                }),
                                a(t.track.distToIdx(u)),
                                function e() {
                                    r = window.requestAnimationFrame(function r(d) {
                                        l || (l = d),
                                        s(!0);
                                        var u = d - l;
                                        u > n && (u = n);
                                        var v = o[i];
                                        if (v[3] < u)
                                            return i++,
                                            r(d);
                                        var c = v[2]
                                          , h = v[4]
                                          , g = v[0]
                                          , p = v[1] * (0,
                                        v[5])(0 === h ? 1 : (u - c) / h);
                                        if (p && t.track.to(g + p),
                                        u < n)
                                            return e();
                                        l = null,
                                        s(!1),
                                        a(null),
                                        t.emit("animationEnded")
                                    })
                                }(),
                                t.emit("animationStarted")
                            }
                        },
                        stop: d,
                        targetIdx: null
                    }
                }(y),
                b)
                    for (var t = 0; t < b.length; t++)
                        (0,
                        b[t])(y);
                y.track.init(y.options.initial || 0),
                y.emit("created")
            }(),
            y
        } catch (t) {
            console.error(t)
        }
    };
    let y = t => {
        var e, i, n, o;
        let r;
        let l = null !== (o = t.options.autoplay) && void 0 !== o ? o : {}
          , s = !1
          , a = null
          , d = null === (n = t.container) || void 0 === n ? void 0 : null === (i = n.closest(".gp-carousel-wrapper")) || void 0 === i ? void 0 : null === (e = i.getElementsByClassName("gp-carousel-dot-container")) || void 0 === e ? void 0 : e[0];
        function u(t) {
            t.forEach(t => {
                t.isIntersecting ? c() : v()
            }
            )
        }
        function v() {
            clearTimeout(r)
        }
        function c() {
            var e, i;
            clearTimeout(r),
            r = setTimeout( () => {
                !s && l.enable && t.next()
            }
            , null !== (i = null === (e = l) || void 0 === e ? void 0 : e.delay) && void 0 !== i ? i : 2e3)
        }
        function h() {
            s = !0,
            v()
        }
        function g() {
            s = !1,
            c()
        }
        t.on("created", () => {
            var e;
            null == d || d.addEventListener("mouseover", h),
            null == d || d.addEventListener("mouseout", g),
            l.pauseOnHover && (t.container.addEventListener("mouseover", h),
            t.container.addEventListener("mouseout", g)),
            (null === (e = t.options.autoplay) || void 0 === e ? void 0 : e.enable) && c()
        }
        ),
        t.on("dragStarted", v),
        t.on("animationEnded", c),
        t.on("updated", t => {
            var e, i;
            l = null !== (i = null === (e = t.options) || void 0 === e ? void 0 : e.autoplay) && void 0 !== i ? i : {},
            c()
        }
        ),
        t.on("destroyed", () => {
            t.container.removeEventListener("mouseover", h),
            t.container.removeEventListener("mouseout", g)
        }
        ),
        t.on("optionsChanged", e => {
            var i, n, o, r;
            (null === (i = e.options.autoplay) || void 0 === i ? void 0 : i.pauseOnHover) === l.pauseOnHover || ((null === (n = e.options.autoplay) || void 0 === n ? void 0 : n.pauseOnHover) && (t.container.addEventListener("mouseover", h),
            t.container.addEventListener("mouseout", g)),
            (null === (o = e.options.autoplay) || void 0 === o ? void 0 : o.pauseOnHover) || (t.container.removeEventListener("mouseover", h),
            t.container.removeEventListener("mouseout", g),
            s = !1)),
            c(),
            (l = null !== (r = e.options.autoplay) && void 0 !== r ? r : {}).enable && (a || !t.container || (a = new IntersectionObserver(u,{
                root: null,
                threshold: 0
            })).observe(t.container),
            c())
        }
        ),
        t.on("destroyed", () => {
            t.container && (t.container.removeEventListener("mouseover", h),
            t.container.removeEventListener("mouseout", g)),
            null == d || d.removeEventListener("mouseover", h),
            null == d || d.removeEventListener("mouseout", g),
            v(),
            a && (a.disconnect(),
            a = null)
        }
        )
    }
      , S = t => {
        if (t)
            return t && "string" == typeof t && ((null == t ? void 0 : t.startsWith("#")) || (null == t ? void 0 : t.startsWith("rgb")) || (null == t ? void 0 : t.startsWith("hsl")) || (null == t ? void 0 : t.startsWith("transparent"))) ? t : `var(--g-c-${t}, ${t})`
    }
      , k = t => {
        let e = new MutationObserver(e => {
            e.forEach( () => {
                t.update()
            }
            )
        }
        )
          , i = {
            childList: !0
        }
          , n = new ResizeObserver(function() {
            o(t),
            t.update()
        }
        )
          , o = t => {
            if (t.options.vertical) {
                r(t);
                return
            }
            l(t)
        }
          , r = t => {
            t.slides.forEach(t => {
                t && (t.style.maxWidth = "",
                t.style.minWidth = "")
            }
            )
        }
          , l = t => {
            t.slides.forEach(t => {
                t && (t.style.maxHeight = "",
                t.style.minHeight = "")
            }
            )
        }
        ;
        t.on("created", () => {
            n.observe(t.container),
            e.observe(t.container, i)
        }
        ),
        t.on("destroyed", () => {
            n.unobserve(t.container),
            e.disconnect()
        }
        )
    }
      , x = ["desktop", "tablet", "mobile"]
      , E = (t, e, i) => {
        var n, o, r, l, s, a;
        switch (e) {
        case "tablet":
            return null !== (o = null !== (n = null == t ? void 0 : t.tablet) && void 0 !== n ? n : null == t ? void 0 : t.desktop) && void 0 !== o ? o : i;
        case "mobile":
            return null !== (s = null !== (l = null !== (r = null == t ? void 0 : t.mobile) && void 0 !== r ? r : null == t ? void 0 : t.tablet) && void 0 !== l ? l : null == t ? void 0 : t.desktop) && void 0 !== s ? s : i;
        default:
            return null !== (a = null == t ? void 0 : t.desktop) && void 0 !== a ? a : i
        }
    }
      , w = (t, e, i) => {
        let n = t.getAttribute("gp-data-interaction")
          , o = JSON.parse(n || "{}");
        t.setAttribute("gp-data-interaction", JSON.stringify({
            ...o,
            [e]: i
        }))
    }
    ;
    function D(t, e, i) {
        return e in t ? Object.defineProperty(t, e, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = i,
        t
    }
    let I = {
        EASE_IN: {
            value: "ease-in",
            formula: t => t * t * t
        },
        EASE_OUT: {
            value: "ease-out",
            formula: t => 1 - Math.pow(1 - t, 3)
        },
        EASE_IN_OUT: {
            value: "ease-in-out",
            formula: t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2
        },
        DEFAULT: {
            value: "default",
            formula: t => 1 + --t * t * t * t * t
        }
    }
      , T = "gem-slider-item"
      , C = "gp-carousel-dot"
      , A = "gp-carousel-dot--active"
      , B = {
        DESKTOP: "desktop",
        TABLET: "tablet",
        MOBILE: "mobile"
    }
      , L = "var(--g-c-highlight, highlight)"
      , O = "var(--g-c-bg-1, bg-1);"
      , N = () => {
        window.removeEventListener("gp-global-loaded", N),
        customElements.get("gp-carousel") || customElements.define("gp-carousel", class extends GP.Component {
            connectedCallback() {
                this.init()
            }
            dispatchEventSelectItem(t) {
                this.trigger && (this.trigger({
                    event: "gp:rollback:select-slide"
                }),
                this.trigger({
                    event: "gp:select-slide",
                    data: t
                }))
            }
            nextToIndex(t) {
                var e;
                null === (e = this.slider) || void 0 === e || e.moveToIdx(t, !0, {
                    duration: 0
                }),
                this.previousIndex = t
            }
            moveToIdx(t) {
                var e, i, n, o;
                let {maxIdx: r=0} = null !== (o = null === (i = this.slider) || void 0 === i ? void 0 : null === (e = i.track) || void 0 === e ? void 0 : e.details) && void 0 !== o ? o : {}
                  , l = t > r ? r : t;
                null === (n = this.slider) || void 0 === n || n.moveToIdx(l)
            }
            nextSlide(t) {
                let {key: e, isRollback: i, element: n} = t;
                if (i) {
                    this.moveToIdx(this.previousIndex - 1);
                    return
                }
                w(n, e, String(this.previousIndex)),
                this.moveToIdx(this.previousIndex + 1)
            }
            changeIndexSlideInteraction(t) {
                let {rel: e} = this.getSliderSetting()
                  , {key: i, data: n, isRollback: o, element: r} = t;
                if (o) {
                    this.moveToIdx(Number(n));
                    return
                }
                w(r, i, String(e)),
                this.moveToIdx(n)
            }
            previousSlide(t) {
                let {key: e, isRollback: i, element: n} = t;
                if (i) {
                    this.moveToIdx(this.previousIndex + 1);
                    return
                }
                w(n, e, String(this.previousIndex)),
                this.moveToIdx(this.previousIndex - 1)
            }
            getSliderOption() {
                var t, e, i, n, o, r, l, s, a, d, u, v, c, h, g, p, m, f, b, y, S, k;
                let x = this.getSlideToShow()
                  , w = this.isMobile();
                return {
                    selector: `#gp-carousel-${this.componentId}>.${T}`,
                    initial: this.getState("moveToIdx") || 0,
                    defaultAnimation: {
                        duration: null !== (S = null === (t = this.styles) || void 0 === t ? void 0 : t.playSpeed) && void 0 !== S ? S : 500,
                        easing: t => {
                            var e;
                            switch (null === (e = this.setting) || void 0 === e ? void 0 : e.animationMode) {
                            case I.EASE_IN.value:
                                return I.EASE_IN.formula(t);
                            case I.EASE_OUT.value:
                                return I.EASE_OUT.formula(t);
                            case I.EASE_IN_OUT.value:
                                return I.EASE_IN_OUT.formula(t);
                            default:
                                return I.DEFAULT.formula(t)
                            }
                        }
                    },
                    dragSpeed: 1,
                    renderMode: "performance",
                    mode: "snap",
                    loop: this.getValueByDevice(null === (e = this.setting) || void 0 === e ? void 0 : e.loop, B.DESKTOP, !1),
                    vertical: this.getValueByDevice(null === (i = this.setting) || void 0 === i ? void 0 : i.vertical, B.DESKTOP, !1),
                    drag: this.getValueByDevice(null === (n = this.setting) || void 0 === n ? void 0 : n.enableDrag, B.DESKTOP, !1),
                    rtl: null === (o = this.setting) || void 0 === o ? void 0 : o.rtl,
                    breakpoints: {
                        "(max-width: 9999px)": {
                            slides: {
                                perView: E(x, "desktop", 4) || 1,
                                spacing: E(null === (r = this.styles) || void 0 === r ? void 0 : r.spacing, "desktop"),
                                origin: this.getOriginCarousel("desktop"),
                                numberOfFullWidthShow: this.getNumberOfFullWidthShow("desktop")
                            },
                            loop: E(null === (l = this.setting) || void 0 === l ? void 0 : l.loop, "desktop", !1),
                            vertical: E(null === (s = this.setting) || void 0 === s ? void 0 : s.vertical, "desktop"),
                            range: this.getMaxNavigationWhenSneak("desktop"),
                            drag: E(null === (a = this.setting) || void 0 === a ? void 0 : a.enableDrag, "desktop", !1)
                        },
                        "(max-width: 1024px)": {
                            slides: {
                                perView: E(x, "tablet", 4) || 1,
                                spacing: E(null === (d = this.styles) || void 0 === d ? void 0 : d.spacing, "tablet"),
                                origin: this.getOriginCarousel("tablet"),
                                numberOfFullWidthShow: this.getNumberOfFullWidthShow("tablet")
                            },
                            loop: E(null === (u = this.setting) || void 0 === u ? void 0 : u.loop, "tablet", !1),
                            vertical: E(null === (v = this.setting) || void 0 === v ? void 0 : v.vertical, "tablet"),
                            range: this.getMaxNavigationWhenSneak("tablet"),
                            drag: E(null === (c = this.setting) || void 0 === c ? void 0 : c.enableDrag, "tablet", !1)
                        },
                        "(max-width: 767px)": {
                            slides: {
                                perView: E(x, "mobile", 4) || 1,
                                spacing: E(null === (h = this.styles) || void 0 === h ? void 0 : h.spacing, "mobile"),
                                origin: this.getOriginCarousel("mobile"),
                                numberOfFullWidthShow: this.getNumberOfFullWidthShow("mobile")
                            },
                            loop: E(null === (g = this.setting) || void 0 === g ? void 0 : g.loop, "mobile", !1),
                            vertical: E(null === (p = this.setting) || void 0 === p ? void 0 : p.vertical, "mobile"),
                            range: this.getMaxNavigationWhenSneak("mobile"),
                            drag: E(null === (m = this.setting) || void 0 === m ? void 0 : m.enableDrag, "mobile", !1)
                        }
                    },
                    autoplay: {
                        delay: (null !== (k = null === (f = this.setting) || void 0 === f ? void 0 : f.autoplayTimeout) && void 0 !== k ? k : 1) * 1e3,
                        pauseOnHover: null === (b = this.setting) || void 0 === b ? void 0 : b.pauseOnHover,
                        enable: null === (y = this.setting) || void 0 === y ? void 0 : y.autoplay
                    },
                    created: t => {
                        this.onCreated(t)
                    }
                    ,
                    updated: () => {
                        if (this.productFormID && !this.isUpdated) {
                            let t = new CustomEvent("activeMoveIndexSlider-" + this.productFormID);
                            window.dispatchEvent(t),
                            this.isUpdated = !0
                        }
                    }
                    ,
                    slideChanged: t => {
                        var e;
                        this.setAttribute("active-index", t.track.details.rel.toString()),
                        this.previousIndex = (null === (e = t.track.details) || void 0 === e ? void 0 : e.rel) || 0;
                        let i = new Event("changeActiveIndex");
                        this.dispatchEvent(i)
                    }
                    ,
                    dragStarted: w ? void 0 : t => {
                        t.container.style.cursor = "grabbing"
                    }
                    ,
                    dragEnded: w ? void 0 : t => {
                        t.container.style.cursor = "auto"
                    }
                    ,
                    animationStarted: w ? void 0 : t => {
                        this.isRunningAnimation ? t.options.defaultAnimation = {
                            duration: 500,
                            easing: t => I.DEFAULT.formula(t)
                        } : this.isRunningAnimation = !0
                    }
                    ,
                    animationEnded: w ? void 0 : t => {
                        var e, i, n;
                        let o = null === (e = this.setting) || void 0 === e ? void 0 : e.animationMode;
                        this.isRunningAnimation = !1,
                        t.options.defaultAnimation = {
                            duration: (null === (i = this.styles) || void 0 === i ? void 0 : i.playSpeed) === 0 ? 1 : (null === (n = this.styles) || void 0 === n ? void 0 : n.playSpeed) || 500,
                            easing(t) {
                                switch (o) {
                                case I.EASE_IN.value:
                                    return I.EASE_IN.formula(t);
                                case I.EASE_OUT.value:
                                    return I.EASE_OUT.formula(t);
                                case I.EASE_IN_OUT.value:
                                    return I.EASE_IN_OUT.formula(t);
                                default:
                                    return I.DEFAULT.formula(t)
                                }
                            }
                        }
                    }
                }
            }
            onCreated(t) {
                this.setSlider(t),
                this.getBackAndNextButton(),
                this.getDotContainer(),
                this.initSliderEvent(),
                this.updateDotClickEvent(),
                this.renderSliderDots(),
                this.checkDisableArrowButton(),
                this.showWrapper()
            }
            setSlider(t) {
                this.slider = t
            }
            getBackAndNextButton() {
                var t, e;
                this.nextButton = null === (t = this.getElementsByClassName(`gp-carousel-action-next ${this.componentId}`)) || void 0 === t ? void 0 : t[0],
                this.backButton = null === (e = this.getElementsByClassName(`gp-carousel-action-back ${this.componentId}`)) || void 0 === e ? void 0 : e[0]
            }
            getDotContainer() {
                var t;
                this.dotContainer = null === (t = this.getElementsByClassName(`gp-carousel-dot-container-${this.componentId}`)) || void 0 === t ? void 0 : t[0]
            }
            initSliderEvent() {
                this.addEventNextAndBackSlide(),
                this.addEventSlideChange(),
                this.addEventAnimationEnded(),
                this.addEventOptionsChange()
            }
            addEventLazyImage() {
                let t = this
                  , e = this.querySelectorAll(`#gp-carousel-${this.componentId} .gem-slider-item`);
                e && t && e.forEach(e => {
                    let i = new IntersectionObserver(t => {
                        t.forEach(t => {
                            if (t.isIntersecting) {
                                let r = t.target.querySelector("img:not(.image-zoom)");
                                if (r && !r.classList.contains("gp_lazyload") && !r.classList.contains("gp_lazyloaded")) {
                                    var e, n, o;
                                    r.classList.add("gp_lazyload"),
                                    null === (o = window) || void 0 === o || null === (n = o.gpLazySizes) || void 0 === n || null === (e = n.loader) || void 0 === e || e.unveil(r)
                                }
                                i.disconnect()
                            }
                        }
                        )
                    }
                    ,{
                        root: t,
                        rootMargin: "100%"
                    });
                    i.observe(e)
                }
                )
            }
            addEventNextAndBackSlide() {
                var t, e;
                null === (t = this.nextButton) || void 0 === t || t.addEventListener("click", t => {
                    var e;
                    t.preventDefault(),
                    null === (e = this.slider) || void 0 === e || e.next()
                }
                ),
                null === (e = this.backButton) || void 0 === e || e.addEventListener("click", t => {
                    var e;
                    t.preventDefault(),
                    null === (e = this.slider) || void 0 === e || e.prev()
                }
                )
            }
            addEventSlideChange() {
                var t;
                null === (t = this.slider) || void 0 === t || t.on("slideChanged", t => {
                    this.setSlider(t),
                    this.checkDisableArrowButton(),
                    setTimeout( () => {
                        this.updateDotColor()
                    }
                    , 10)
                }
                )
            }
            checkDisableArrowButton() {
                var t, e, i, n, o;
                let r = null === (t = this.slider) || void 0 === t ? void 0 : t.options.loop;
                if (r)
                    return;
                let {abs: l=0, maxIdx: s=0} = null !== (o = null === (i = this.slider) || void 0 === i ? void 0 : null === (e = i.track) || void 0 === e ? void 0 : e.details) && void 0 !== o ? o : {}
                  , a = this.getValueByDevice(null === (n = this.setting) || void 0 === n ? void 0 : n.navigationStyle, this.getDeviceName(), "none");
                if ("none" !== a) {
                    if (s === 1 / 0)
                        return;
                    this.checkDisabledForBackButton(l),
                    this.checkDisabledForNextButton(l, s)
                }
            }
            checkDisabledForBackButton(t) {
                if (this.backButton) {
                    if (0 === t) {
                        this.disableArrowButton(this.backButton);
                        return
                    }
                    this.enableArrowButton(this.backButton)
                }
            }
            checkDisabledForNextButton(t, e) {
                if (this.nextButton) {
                    if (t === e) {
                        this.disableArrowButton(this.nextButton);
                        return
                    }
                    this.enableArrowButton(this.nextButton)
                }
            }
            disableArrowButton(t) {
                this.isHiddenArrowWhenDisabled && (t.classList.add("visibility-hidden"),
                t.dataset.hidden = "true"),
                t.disabled = !0
            }
            enableArrowButton(t) {
                this.isHiddenArrowWhenDisabled && (t.classList.remove("visibility-hidden"),
                t.dataset.hidden = "false"),
                t.disabled = !1
            }
            addEventAnimationEnded() {
                var t;
                null === (t = this.slider) || void 0 === t || t.on("animationEnded", t => {
                    this.setSlider(t)
                }
                )
            }
            updateDotColor() {
                var t, e, i, n, o;
                let {isInfinity: r, rel: l, slidePerPage: s} = this.getSliderSetting()
                  , a = this.getActiveIndexDot(r, l, s)
                  , d = null === (e = this.dotContainer) || void 0 === e ? void 0 : null === (t = e.getElementsByClassName(`${A}`)) || void 0 === t ? void 0 : t[0];
                if (!d)
                    return;
                let u = (null === (i = d.dataset) || void 0 === i ? void 0 : i.index) ? parseInt(null === (n = d.dataset) || void 0 === n ? void 0 : n.index, 10) : void 0;
                if (u === a)
                    return;
                let {activeBgc: v, inactiveBgc: c} = this.getDotBackgroundColorFrom(d);
                d.style.backgroundColor = c || O,
                d.classList.remove(A);
                let h = null === (o = this.dotContainer) || void 0 === o ? void 0 : o.querySelector(`#gp-carousel-${this.componentId}-${a}`);
                h && (h.style.backgroundColor = v || L,
                h.classList.add(A))
            }
            getDotBackgroundColorFrom(t) {
                let e = t.previousElementSibling
                  , i = "";
                if (e)
                    i = e.style.backgroundColor;
                else {
                    var n;
                    let e = t.nextElementSibling;
                    i = (null === (n = e.style) || void 0 === n ? void 0 : n.backgroundColor) || ""
                }
                let o = t.style.backgroundColor;
                return {
                    activeBgc: o,
                    inactiveBgc: i
                }
            }
            addEventOptionsChange() {
                var t;
                null === (t = this.slider) || void 0 === t || t.on("optionsChanged", t => {
                    this.setSlider(t),
                    this.updateDotClickEvent(),
                    this.renderSliderDots(),
                    this.checkDisableArrowButton()
                }
                )
            }
            updateDotClickEvent() {
                this.dotContainer && this.dotContainer.addEventListener("click", t => {
                    t.preventDefault();
                    let e = t.target;
                    !e.classList.contains(C) || e.classList.contains(A) || (this.changeStyleForDots(e),
                    this.goToSlideByIndex(this.getSlideIndexByDot(e)))
                }
                )
            }
            changeStyleForDots(t) {
                var e, i;
                let n = null === (i = this.dotContainer) || void 0 === i ? void 0 : null === (e = i.getElementsByClassName(`${A}`)) || void 0 === e ? void 0 : e[0];
                if (!n)
                    return;
                let o = n.style.backgroundColor
                  , r = t.style.backgroundColor;
                t.style.backgroundColor = o,
                t.classList.add(A),
                n.style.backgroundColor = r,
                n.classList.remove(A)
            }
            getSlideIndexByDot(t) {
                var e;
                return (null === (e = t.dataset) || void 0 === e ? void 0 : e.index) ? parseInt(t.dataset.index, 10) : void 0
            }
            goToSlideByIndex(t) {
                var e, i, n;
                if (void 0 === t)
                    return;
                let o = this.getValueByDevice(null === (e = this.setting) || void 0 === e ? void 0 : e.loop, this.getDeviceName(), !1) ? t : this.getIndexSlideItem(t);
                E(null === (i = this.setting) || void 0 === i ? void 0 : i.sneakPeak, this.getDeviceName()) && (o = t),
                this.previousIndex = o,
                null === (n = this.slider) || void 0 === n || n.moveToIdx(o)
            }
            getIndexSlideItem(t) {
                var e, i;
                let n = null !== (i = null === (e = this.slider) || void 0 === e ? void 0 : e.slides.length) && void 0 !== i ? i : 0
                  , o = this.getSlideToShow()
                  , r = this.getValueByDevice(o, this.getDeviceName(), 4)
                  , l = t * r;
                return l >= n - r && (l = n - r),
                l
            }
            renderSliderDots(t=!1) {
                var e;
                let {isInfinity: i, rel: n, slidePerPage: o} = this.getSliderSetting()
                  , r = this.getValueByDevice(null === (e = this.setting) || void 0 === e ? void 0 : e.dotStyle, this.getDeviceName(), "none");
                if ("none" === r)
                    return;
                let l = t ? [0] : this.getDotItems();
                if (!this.dotContainer || 0 === l.length)
                    return;
                let s = "";
                l.forEach(t => {
                    let e = this.getActiveIndexDot(i, n, o)
                      , r = t === e;
                    s += this.renderDot({
                        idx: t,
                        isActive: r
                    })
                }
                ),
                this.dotContainer.innerHTML = s
            }
            renderDot(t) {
                var e, i, n;
                let {idx: o, isActive: r} = t
                  , l = r ? null === (e = this.setting) || void 0 === e ? void 0 : e.dotActiveColor : null === (i = this.setting) || void 0 === i ? void 0 : i.dotColor
                  , s = r ? L : O;
                return `
            <button
              id="gp-carousel-${this.componentId}-${o}"
              data-index="${o}"
              aria-label="dot"
              style="background-color: ${l ? S(this.getValueByDevice(l, this.getDeviceName(), void 0)) : s};
              aspect-ratio: 1/1;
              width: ${this.getValueByDevice(null === (n = this.setting) || void 0 === n ? void 0 : n.dotSize, this.getDeviceName(), 12)}px;
              border-radius: 9999px;
              box-shadow: 0 4px 6px -1px rgba(0,0,0,.1);
              --tw-shadow: 0 2px 4px -2px rgba(0,0,0,.1);
              --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color),0 2px 4px -2px var(--tw-shadow-color);"
              class="${C} ${r ? `${A} gem-slider-dot-active` : "gem-slider-dot-inactive"}"
            >
            </button>
          `
            }
            getSliderSetting() {
                var t, e, i, n, o, r, l, s, a, d, u, v;
                let c = this.getSlideToShow();
                return {
                    isInfinity: (null === (i = this.slider) || void 0 === i ? void 0 : null === (e = i.track) || void 0 === e ? void 0 : null === (t = e.details) || void 0 === t ? void 0 : t.maxIdx) === 1 / 0,
                    slidePerPage: this.getValueByDevice(c, this.getDeviceName(), 4),
                    totalSliderItem: null !== (u = null === (l = this.slider) || void 0 === l ? void 0 : null === (r = l.track) || void 0 === r ? void 0 : null === (o = r.details) || void 0 === o ? void 0 : null === (n = o.slides) || void 0 === n ? void 0 : n.length) && void 0 !== u ? u : 0,
                    rel: null !== (v = null === (d = this.slider) || void 0 === d ? void 0 : null === (a = d.track) || void 0 === a ? void 0 : null === (s = a.details) || void 0 === s ? void 0 : s.rel) && void 0 !== v ? v : 0
                }
            }
            getValueByDevice(t, e, i) {
                var n, o, r, l, s, a;
                let d = e || this.getDeviceName();
                switch (d) {
                case B.MOBILE:
                    return null !== (r = null !== (o = null !== (n = null == t ? void 0 : t.mobile) && void 0 !== n ? n : null == t ? void 0 : t.tablet) && void 0 !== o ? o : null == t ? void 0 : t.desktop) && void 0 !== r ? r : i;
                case B.TABLET:
                    return null !== (s = null !== (l = null == t ? void 0 : t.tablet) && void 0 !== l ? l : null == t ? void 0 : t.desktop) && void 0 !== s ? s : i;
                default:
                    return null !== (a = null == t ? void 0 : t.desktop) && void 0 !== a ? a : i
                }
            }
            setWrapperHeight() {
                this.getSliderWrapper(),
                this.checkHeightAndAddEventResize()
            }
            setCarouselGap() {
                var t, e, i, n, o, r;
                this.getSliderSelector(),
                this.sliderSelector && (null === (t = this.sliderSelector) || void 0 === t || t.style.removeProperty("--cg"),
                null === (e = this.sliderSelector) || void 0 === e || e.style.removeProperty("--cg-tablet"),
                null === (i = this.sliderSelector) || void 0 === i || i.style.removeProperty("--cg-mobile"),
                null === (n = this.sliderSelector) || void 0 === n || n.style.removeProperty("--rg"),
                null === (o = this.sliderSelector) || void 0 === o || o.style.removeProperty("--rg-tablet"),
                null === (r = this.sliderSelector) || void 0 === r || r.style.removeProperty("--rg-mobile"))
            }
            getSliderWrapper() {
                var t;
                this.sliderWrapper = null === (t = this.getElementsByClassName("gp-carousel-wrapper")) || void 0 === t ? void 0 : t[0]
            }
            getSliderSelector() {
                this.sliderSelector = this.querySelector(`#gp-carousel-${this.componentId}`)
            }
            setCarouselOffset() {
                let t = this.querySelector(`#gp-carousel-${this.componentId}>.${T}`);
                t && (null == t || t.style.removeProperty("--ml"),
                null == t || t.style.removeProperty("--ml-tablet"),
                null == t || t.style.removeProperty("--ml-mobile"))
            }
            showWrapper() {
                var t;
                let e = null === (t = this.getElementsByClassName("gp-carousel-wrapper")) || void 0 === t ? void 0 : t[0];
                e && (e.style.visibility = "")
            }
            checkHeightAndAddEventResize() {
                this.checkWrapperHeight(),
                window.addEventListener("resize", () => {
                    this.checkWrapperHeight()
                }
                )
            }
            checkWrapperHeight() {
                var t, e;
                let i = this.getDeviceName();
                if (null === (t = null === (e = this.setting) || void 0 === e ? void 0 : e.vertical) || void 0 === t ? void 0 : t[i]) {
                    let t = this.getHeightByDevice(i);
                    if (!t || !this.sliderWrapper)
                        return;
                    this.sliderWrapper.style.height = t
                }
            }
            getHeightByDevice(t) {
                var e, i, n, o, r, l, s;
                let a = null === (e = this.styles) || void 0 === e ? void 0 : e.sizeSetting;
                switch (t) {
                case "desktop":
                    return null == a ? void 0 : null === (i = a.desktop) || void 0 === i ? void 0 : i.height;
                case "tablet":
                    return (null == a ? void 0 : null === (n = a.tablet) || void 0 === n ? void 0 : n.height) || (null == a ? void 0 : null === (o = a.desktop) || void 0 === o ? void 0 : o.height);
                case "mobile":
                    return (null == a ? void 0 : null === (r = a.mobile) || void 0 === r ? void 0 : r.height) || (null == a ? void 0 : null === (l = a.tablet) || void 0 === l ? void 0 : l.height) || (null == a ? void 0 : null === (s = a.desktop) || void 0 === s ? void 0 : s.height)
                }
            }
            getDeviceName() {
                return window.innerWidth < 768 ? B.MOBILE : window.innerWidth >= 768 && window.innerWidth < 1025 ? B.TABLET : B.DESKTOP
            }
            updateOptionStyles(t) {
                this.styles = {
                    ...this.styles,
                    ...t
                },
                this.checkWrapperHeight()
            }
            rerender() {
                var t;
                null === (t = this.slider) || void 0 === t || t.update()
            }
            constructor() {
                super(),
                D(this, "componentId", ""),
                D(this, "setting", void 0),
                D(this, "styles", void 0),
                D(this, "slider", void 0),
                D(this, "sliderWrapper", void 0),
                D(this, "nextButton", void 0),
                D(this, "backButton", void 0),
                D(this, "dotContainer", void 0),
                D(this, "isHiddenArrowWhenDisabled", void 0),
                D(this, "productFormID", void 0),
                D(this, "sliderSelector", void 0),
                D(this, "isRunningAnimation", !1),
                D(this, "isUpdated", !1),
                D(this, "previousIndex", 0),
                D(this, "init", () => {
                    var t;
                    let e = this.closest(".gps > section");
                    if (null == e ? void 0 : e.classList.contains("gps-lazy")) {
                        null == e || e.addEventListener("GpLazyLoaded", this.init);
                        return
                    }
                    if (null == e || e.removeEventListener("GpLazyLoaded", this.init),
                    this.componentId = this.getState("id"),
                    this.productFormID = null === (t = this.closest("gp-product form")) || void 0 === t ? void 0 : t.getAttribute("id"),
                    !this.componentId)
                        return;
                    let i = this.getAttribute("product-media");
                    if (this.setting = this.getState("setting"),
                    this.styles = this.getState("styles"),
                    this.isHiddenArrowWhenDisabled = this.getState("isHiddenArrowWhenDisabled"),
                    i && "1" === i) {
                        this.getDotContainer(),
                        this.renderSliderDots(!0);
                        let t = this.querySelector("img[data-srcset]");
                        t && !t.classList.contains("gp_lazyload") && t.classList.add("gp_lazyload");
                        return
                    }
                    this.slider = new b(`#gp-carousel-${this.componentId}`,this.getSliderOption(),[t => k(t), y]),
                    this.addEventLazyImage(),
                    this.setWrapperHeight(),
                    this.setCarouselGap(),
                    this.setCarouselOffset(),
                    this.onListenerChangeSlideInteraction();
                    let n = this.querySelector(".gem-slider");
                    null == n || n.addEventListener("click", t => {
                        var e;
                        let i = null === (e = t.target.closest(".gem-slider-item")) || void 0 === e ? void 0 : e.getAttribute("data-index");
                        this.dispatchEventSelectItem(Number(i))
                    }
                    )
                }
                ),
                D(this, "getSneakPeakByDevice", () => {
                    var t;
                    return E(null === (t = this.setting) || void 0 === t ? void 0 : t.sneakPeak, this.getDeviceName(), !1)
                }
                ),
                D(this, "isMobile", () => window.innerWidth < 768),
                D(this, "getNumberOfFullWidthShow", t => {
                    var e, i, n;
                    let o = "center" === E(null === this || void 0 === this ? void 0 : null === (e = this.setting) || void 0 === e ? void 0 : e.sneakPeakType, t) ? 2 : 1;
                    return "number" == typeof E(null === (i = this.setting) || void 0 === i ? void 0 : i.itemNumber, t, 4) ? E(null === (n = this.setting) || void 0 === n ? void 0 : n.itemNumber, t, 4) - o : void 0
                }
                ),
                D(this, "getOriginCarousel", t => {
                    var e, i;
                    let n = "center" === E(null === (e = this.setting) || void 0 === e ? void 0 : e.sneakPeakType, t) && E(null === (i = this.setting) || void 0 === i ? void 0 : i.sneakPeak, t) ? "center" : "auto";
                    return n
                }
                ),
                D(this, "getMaxNavigationWhenSneak", t => {
                    var e, i, n, o;
                    if ("center" !== this.getOriginCarousel(t))
                        return {};
                    let r = (null === (i = this.setting) || void 0 === i ? void 0 : null === (e = i.childItem) || void 0 === e ? void 0 : e.length) || 1
                      , l = Number(E(this.getSlideToShow(), t, 1)) || 2;
                    E(null === this || void 0 === this ? void 0 : null === (n = this.setting) || void 0 === n ? void 0 : n.sneakPeak, t) && (l = Math.trunc(Number(this.getNumberOfFullWidthShow(t)) || 1));
                    let s = r - l
                      , a = E(null === (o = this.setting) || void 0 === o ? void 0 : o.loop, t, !1);
                    return a ? {
                        max: void 0
                    } : {
                        max: s
                    }
                }
                ),
                D(this, "getActiveIndexDot", (t, e, i) => {
                    let n = t ? e : Math.ceil(e / i);
                    return this.getSneakPeakByDevice() && (n = e),
                    n
                }
                ),
                D(this, "getSlideToShowFromOldData", () => {
                    var t;
                    if (!(null === (t = this.setting) || void 0 === t ? void 0 : t.slidesToShow))
                        return null;
                    let e = {};
                    return x.forEach(t => {
                        var i;
                        let n = E(null === (i = this.setting) || void 0 === i ? void 0 : i.slidesToShow, t);
                        e[t] = n ? "auto" === n ? 4 : n : 1
                    }
                    ),
                    e
                }
                ),
                D(this, "getSlideToShow", () => {
                    let t = this.getSlideToShowFromOldData();
                    if (t)
                        return t;
                    let e = {};
                    return x.forEach(t => {
                        var i, n, o, r, l, s, a, d;
                        let u = E(null === (i = this.setting) || void 0 === i ? void 0 : i.sneakPeak, t)
                          , v = u ? "center" === E(null === (n = this.setting) || void 0 === n ? void 0 : n.sneakPeakType, t) ? null !== (a = E(null === (o = this.setting) || void 0 === o ? void 0 : o.sneakPeakOffsetCenter, t)) && void 0 !== a ? a : 0 : null !== (d = E(null === (r = this.setting) || void 0 === r ? void 0 : r.sneakPeakOffsetForward, t)) && void 0 !== d ? d : 0 : 0
                          , c = E(null === (l = this.setting) || void 0 === l ? void 0 : l.itemNumber, t) || 0
                          , h = "center" === E(null === (s = this.setting) || void 0 === s ? void 0 : s.sneakPeakType, t) ? -2 : -1;
                        e[t] = "auto" === c ? c : c + v / 100 * h
                    }
                    ),
                    e
                }
                ),
                D(this, "getDotItems", () => {
                    let {isInfinity: t, totalSliderItem: e, slidePerPage: i} = this.getSliderSetting()
                      , n = [];
                    if (this.getSneakPeakByDevice()) {
                        let i = this.getDeviceName()
                          , o = this.getNumberOfFullWidthShow(i);
                        n = Array.from({
                            length: t ? e : e - (o || 0) + 1
                        }, (t, e) => e)
                    } else
                        n = Array.from({
                            length: t ? e : Math.ceil(e / i)
                        }, (t, e) => e);
                    return n
                }
                ),
                D(this, "onListenerChangeSlideInteraction", () => {
                    this.onTrigger && (this.onTrigger({
                        event: "gp:change-previous-slide"
                    }, t => {
                        let {isRollback: e, data: i, uniqueStorageKey: n} = t || {};
                        this.previousSlide({
                            isRollback: e,
                            data: i,
                            key: n,
                            element: this
                        })
                    }
                    ),
                    this.onTrigger({
                        event: "gp:change-next-slide"
                    }, t => {
                        let {isRollback: e, uniqueStorageKey: i, data: n} = t || {};
                        this.nextSlide({
                            isRollback: e,
                            data: n,
                            key: i,
                            element: this
                        })
                    }
                    ),
                    this.onTrigger({
                        event: "gp:change-index-slide"
                    }, t => {
                        let {isRollback: e, uniqueStorageKey: i, data: n} = t || {};
                        this.changeIndexSlideInteraction({
                            isRollback: e,
                            data: n,
                            key: i,
                            element: this
                        })
                    }
                    ))
                }
                )
            }
        }
        )
    }
    ;
    "completed" === window.gpReadyState ? N() : window.addEventListener("gp-global-loaded", N)
}();
